import { profile } from '../data/profile';

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div>
          <p className="footer__name">{profile.personal.fullName}</p>
          <p className="footer__meta">Austin, TX · {profile.metadata.workAuthorization}</p>
        </div>
        <p className="footer__copy">© {year} {profile.personal.fullName}</p>
      </div>
    </footer>
  );
}
